import React from 'react';
import { Link } from 'react-router-dom';
import { toCalendrier } from '../../App_Code/Utils';
import PopupTelecharger from '../PopupTelecharger';

const Card = ({ Titre, SousTitre, children }) => (
    <div className="card mb-3">
        <div className="card-body" style={{padding:"0.5rem 1.25rem"}}>
            <h6 className="card-title">{Titre}</h6>
            {/* <h6 className="card-subtitle mb-2 text-muted">{SousTitre}</h6> */}
            {children}
        </div>
    </div>
);

const InformationPillule = ({
    AjouterFiltre, Badge, Valeur, ExtraClass,
}) => {
    if (!Valeur) return null;

    return (
        <button
            // onClick={(event) => {
            //     event.preventDefault();
            //     AjouterFiltre(Valeur);
            // }}
            className={`btn badge badge-pill ${Badge} mr-2`}
        >
            {ExtraClass && <i className={ExtraClass} title={Valeur} />} {Valeur}
        </button>
    );
};

const Details = ({
    Type, Prest, Act, VisiblePar, DateDeb, actions,
}) => {
    const icone = Type === 0 ? 'fa-file-alt' : 'fa-envelope';

    const AjoutFiltreAct = (filtre) => {
        actions.docFiltrePrest(Prest);
        actions.docFiltreAct(filtre);
    };

    return (
        <div className="media">
            <div className="mr-3">
                <i className={`far fa-3x text-dark ${icone}`} />
            </div>
            <div className="media-body">
                <InformationPillule AjouterFiltre={actions.docFiltrePrest} Badge="badge-primary" Valeur={Prest} />
                <InformationPillule AjouterFiltre={AjoutFiltreAct} Badge="badge-success" Valeur={Act} />
                <span className={`badge badge-pill ${VisiblePar.Couleur}`} title={VisiblePar.Legende}>
                    <i className={VisiblePar.Icone} /> {VisiblePar.Titre}
                </span>
                <p className="text-muted mb-0">{toCalendrier(DateDeb)}</p>
            </div>
        </div>
    );
};

const Boutons = ({ Doc }) => (
    <React.Fragment>
        <button type="button" className="btn btn-outline-primary mt-3 mr-3" onClick={() => PopupTelecharger(Doc.Id)}>
            <i className="fa fas fa-download" /> Télécharger
        </button>
        <Link
            to={{
                pathname: '/MesDocuments/Document',
                state: { Id: Doc.Id },
            }}
            className="btn btn-outline-dark mt-3 mr-3"
        >
            <i className="fa fas fa-eye" /> Visualiser
        </Link>
        {Doc.Type === 1 && (
            <Link
                to={{
                    pathname: '/MesDocuments/SuiviCourrier',
                    state: { Id: Doc.Id, TypeLib: Doc.TypeLib },
                }}
                title="Informations complémentaires sur l'envoi"
                className="btn btn-outline-secondary mt-3"
            >
                <i className="fas fa-info-circle" /> Informations
            </Link>
        )}
    </React.Fragment>
);

const CardRapport = ({ Doc, actions }) => (
        <Card Titre={Doc.Objet} SousTitre={Doc.TypeLib}>
            <div className="card-text">
                <Details {...Doc} actions={actions} />
            </div>
            <Boutons Doc={Doc} />
        </Card>
);

export default CardRapport;



// WEBPACK FOOTER //
// ./src/components/MonAG/CardRapport.js